<template>
	<div class="m-detail">
		<div class="m-detail-bg" :class="{ 'sc-red': isSCIOS }"></div>
		<section s-cr="#FFFFFF" class="m-detail-head">
			<header>
				<span f-font-PFM class="g-fs36 f-ellipsis">{{
					detailObj.fundName || detailObj.name || "--"
				}}</span>
				<span f-font-PFM class="g-fs36" @click="goFST">
					<img
						v-if="!isIjijinApp"
						src="../../assets/images/allow-right-black.png"
						alt="#"
					/>
				</span>
			</header>
			<p f-font-PFR class="g-fs24 f-ell">
				{{ detailObj.introduce }}
			</p>
			<div class="m-detail-valuation">
				<h3
					f-font-PFM
					class="f-bold"
					:class="{
						green: detailObj.evaluateStatus === '0',
						yellow: detailObj.evaluateStatus === '1',
						red: detailObj.evaluateStatus === '2'
					}"
				>
					{{ evaluateStatus[detailObj.evaluateStatus] || "--" }}
				</h3>
				<p f-font-PFR>
					该指数适用<span
						>{{ detailObj.applyArea
						}}{{
							`${detailObj.applyArea === "PE" ? "(市盈率)" : "(市净率)"}`
						}}</span
					>估值，估值比过去<span>{{
						detailObj.evaluateRate | formatProfit(true)
					}}</span
					>的时间低
				</p>
				<fund-progress :rate="rate"></fund-progress>
			</div>
		</section>
		<valuation :time="time" :fiveIndex="fiveIndex"></valuation>
		<interval></interval>
		<chart :historyList="historyList"></chart>
		<interval></interval>
		<trend
			v-if="relateFunds && relateFunds.length > 0"
			:relateFunds="relateFunds"
		></trend>
		<interval></interval>
		<foot></foot>
	</div>
</template>

<script>
	import FundProgress from "@/components/Progress"
	import Interval from "@/components/Interval"
	import Valuation from "./valuation"
	import Foot from "@/components/Footer"
	import Trend from "./trend"
	import Chart from "./chart"
	import {
		goStockPage,
		getTimeDate,
		isSdk,
		config
	} from "@/assets/js/common.js"
	import {
		fetchIndexDetail,
		getTime,
		getFundDetail,
		fetchOuterFund,
		fetchConfig,
		fetchInnerFund
	} from "@/assets/js/fetchData"
	import { changeTitleBar } from "@/assets/js/fn.js"
	import { reportError } from '@/utils/monitor.js'
	import { CONFIG_TYPE, SHOW_TYPE } from "@/assets/js/const.js"

	export default {
		name: "detail",
		components: {
			FundProgress,
			Valuation,
			Interval,
			Trend,
			Chart,
			Foot
		},
		computed: {
			isIjijinApp: function () {
				return isSdk() === false && _.urlInfo.sys === "ijijin"
			}
		},
		data() {
			return {
				detailObj: {},
				time: "",
				fiveIndex: {
					pe: "",
					pePercent: "",
					pb: "",
					pbPercent: "",
					roe: ""
				},
				historyList: {
					pbhistoryList: [],
					pehistoryList: [],
					time: "",
					applyArea: ""
				},
				relateFunds: [],
				evaluateStatus: {
					0: "较低",
					1: "适中",
					2: "较高"
				},
				rate: "",
				uniqueId: ""
			}
		},
		methods: {
			_fetchIndexDetail() {
				let obj = {}
				obj.marketEvaluateID = _.fn.getUrlParam("code")
				fetchIndexDetail(obj)
					.then(async res => {
						const {
							pe,
							pePercent,
							pb,
							pbPercent,
							roe,
							pbhistoryList,
							pehistoryList
						} = res
						this.historyList.pbhistoryList = []
						this.historyList.pehistoryList = []
						this.relateFunds = []
						this.rate = res.evaluateRate
						this.detailObj = { ...res } || {}
						this.historyList.applyArea = res.applyArea
						this.fiveIndex.pe = pe
						this.fiveIndex.pePercent = pePercent
						this.fiveIndex.pb = pb
						this.fiveIndex.pbPercent = pbPercent
						this.fiveIndex.roe = roe
						if (pbhistoryList && pbhistoryList.length > 0) {
							pbhistoryList.sort((a, b) => Number(a.date) - Number(b.date))
							pbhistoryList.forEach(item => {
								item.value = Number(Number(item.value).toFixed(2))
								this.historyList.pbhistoryList.push({ ...item })
							})
						}

						if (pehistoryList && pehistoryList.length > 0) {
							pehistoryList.sort((a, b) => Number(a.date) - Number(b.date))
							pehistoryList.forEach(item => {
								item.value = Number(Number(item.value).toFixed(2))
								this.historyList.pehistoryList.push({ ...item })
							})
						}
						const { fundCode: outterFundCode, fundName: outterFundName } =
							await this.handleOuterFund(res)
						if (outterFundCode && outterFundName) {
							let obj = {
								fundCode: outterFundCode,
								fundName: outterFundName,
								fundText: res.outterText,
								fundType: "outter"
							}
							let result = await this._getFundDetail(outterFundCode)
							this.relateFunds.push(Object.assign(obj, result))
						}
						const { fundCode: innerFundCode, fundName: innerFundName } =
							await this.handleInnerFund(res)
						if (
							(_.urlInfo.sys === "ths" || isSdk()) &&
							innerFundCode &&
							innerFundName
						) {
							let obj = {
								fundCode: innerFundCode,
								fundName: innerFundName,
								fundText: res.innerText,
								fundType: "inner"
							}
							let result = await this._getFundDetail(innerFundCode)
							this.relateFunds.push(Object.assign(obj, result))
						}
					})
					.catch(e => {
						console.log(e)
						reportError('js', 'error fetchIndexDetail promise', e);
						this.$toast("网络错误，请稍后再试")
					})
			},
			_getTime() {
				getTime()
					.then(res => {
						this.time = getTimeDate(res * 1000) || ""
						this.historyList.time = getTimeDate(res * 1000) || ""
					})
					.catch(e => {
						console.log(e)
						reportError('js', 'error getTime promise', e);
						this.$toast("网络错误，请稍后再试")
					})
			},
			goFST() {
				if (config.isSharePage) return
				if (this.isIjijinApp) {
					return
				}
				const { thscodeHq, marketid } = this.detailObj
				console.log(thscodeHq, marketid)
				_.log().jumpPageStat("fenshi", "seat_null")
				if (thscodeHq) {
					goStockPage(thscodeHq, marketid)
				}
			},
			_getFundDetail(code) {
				return new Promise((resolve, reject) => {
					getFundDetail(code)
						.then(res => {
							if (res.data) {
								let detail = res.data[code]
								let max = detail.year
								let text = "近1年涨幅"
								max = Number(max) > Number(detail.hyear) ? max : detail.hyear
								text = Number(max) > Number(detail.hyear) ? text : "近6月涨幅"
								max = Number(max) > Number(detail.tmonth) ? max : detail.tmonth
								text = Number(max) > Number(detail.tmonth) ? text : "近3月涨幅"
								max = Number(max) > Number(detail.month) ? max : detail.month
								text = Number(max) > Number(detail.month) ? text : "近1月涨幅"
								resolve({
									profit: max,
									text
								})
							}
						})
						.catch(e => {
							console.log(e)
							reportError('js', 'error getFundDetail promise', e);
							reject()
						})
				})
			},
			async handleOuterFund(indexDetail) {
				// 1. 优先从客户端给的链接参数取场外基金
				const fundCode = _.fn.getUrlParam("fundCode")
				const fundName = decodeURI(_.fn.getUrlParam("fundName"))
				const { outterFund, outterName } = indexDetail
				const DEFAULT_FUND_INFO = {
					fundName: outterName,
					fundCode: outterFund
				}
				if (fundCode && fundName) {
					return {
						fundName,
						fundCode
					}
				}
				// 2. 取后台配置：走流量分发
				try {
					const indexCode = _.fn.getUrlParam("code")
					const { outterConfigType: configType } =
						await fetchConfig(indexCode)
					if (configType === CONFIG_TYPE.RECOMMEND) {
						const { show, fundName, fundCode } = await fetchOuterFund(indexCode, this.uniqueId)
						// 接口返回有效推荐产品
						if (show === SHOW_TYPE.SHOW && fundName && fundCode) {
							return {
								fundName,
								fundCode
							}
						}
					}
				} catch (error) {
					console.log("获取后台配置或场外单品推荐失败", error)
				}
				// 3. 接口没有返回有效推品，走兜底的运营配置
				return DEFAULT_FUND_INFO
			},
			async handleInnerFund(indexDetail) {
				const { innerFund, innerName } = indexDetail
				const DEFAULT_FUND_INFO = {
					fundName: "",
					fundCode: ""
				}
				// 1. 有运营配置，优先走运营配置
				if (innerFund && innerName) {
					return {
						fundName: innerName,
						fundCode: innerFund
					}
				}
				// 2. 没有运营配置，走流量分发
				const { marketid, thscodeHq } = this.detailObj
				if (thscodeHq && marketid) {
					try {
						const { show, fundName, fundCode } = await fetchInnerFund(
							marketid,
							thscodeHq,
							this.uniqueId
						)
						if (show === SHOW_TYPE.SHOW && fundName && fundCode) {
							return {
								fundName,
								fundCode
							}
						}
					} catch (error) {
						console.log("获取场内单品推荐失败", error)
					}
				}
				// 3. 兜底方案，返回空的基金信息，不展示
				return DEFAULT_FUND_INFO
			}
		},
		mounted() {
			const DEFAULT_UNIQUE_ID = '0';
			this.uniqueId = String(getUserid()) || DEFAULT_UNIQUE_ID;
			this._fetchIndexDetail()
			this._getTime()
			changeTitleBar("#FF330A")
			if (_.urlInfo.sys === "ths" && _.platform.osInfo === "iphone") {
				this.isSCIOS = true
			}
			_.hdShare({
				flag: "1",
				title: "指数估值",
				shareUrl: `https://${config.testDev ? "test" : ""}fund.10jqka.com.cn/${
					_.urlInfo.sys === "ths" ? "scym_scsy" : "ifundapp_web"
				}/public/sf/indexValuation/dist/detail$FF330A.html?code=${_.fn.getUrlParam(
					"code"
				)}&share=true#/`,
				description: "学会估值，轻松投资。"
			})
			if (config.isSharePage) {
				_.backWash({
					url: `https://${_.urlInfo.test ? "test" : ""}fund.10jqka.com.cn/${
						_.urlInfo.sys === "ths" ? "scym_scsy" : "ifundapp_app"
					}/public/sf/indexValuation/dist/detail$FF330A.html?code=${_.fn.getUrlParam(
						"code"
					)}#/`,
					statConfig: {
						pageId: `fund_mkt_20210517_index_${_.fn.getUrlParam("code")}`,
						urlVer: "FW-1045"
					}
				})
			} else {
				_.statSet({
					pageid: `fund_mkt_20210517_index_${_.fn.getUrlParam("code")}`,
					url_ver: "FW-1045",
					bottom: false
				})
			}
		}
	}
</script>

<style lang="less">
	.m-detail {
		position: relative;
		.m-detail-bg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100vw;
			height: 450px;
			background-image: linear-gradient(
				1deg,
				rgba(255, 147, 55, 0) 0%,
				#ff330a 66%
			);
			z-index: -1;
			&.sc-red {
				background-image: linear-gradient(
					1deg,
					rgba(255, 147, 55, 0) 0%,
					#e83030 66%
				);
			}
		}
		.m-detail-head {
			padding: 36px 32px 48px;
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 8px;
				span {
					line-height: 50px;
					&:last-child {
						position: relative;
						padding-right: 20px;
					}
				}
				img {
					width: 16px;
					height: 24px;
					margin-left: 8px;
				}
			}
		}
		.m-detail-valuation {
			box-sizing: border-box;
			width: 100%;
			padding: 32px 24px;
			background: #ffffff;
			border: 1px solid #f6f6f6;
			box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.04);
			border-radius: 16px;
			text-align: center;
			margin-top: 48px;
			h3 {
				display: inline-block;
				position: relative;
				font-size: 36px;
				line-height: 50px;
				color: rgba(0, 0, 0, 0.8);
				&.green {
					color: #00cc22;
				}
				&.yellow {
					color: #ffaa00;
				}
				&.red {
					color: #ff330a;
				}
				&::before {
					content: "";
					position: absolute;
					top: 50%;
					left: -48px;
					width: 24px;
					height: 1px;
					background: #e6e6e6;
					transform: translateY(-50%) scale(1, 0.5);
				}
				&::after {
					content: "";
					position: absolute;
					top: 50%;
					right: -48px;
					width: 24px;
					height: 1px;
					background: #e6e6e6;
					transform: translateY(-50%) scale(1, 0.5);
				}
			}
			p {
				font-size: 24px;
				color: #999999;
				line-height: 38px;
				font-weight: 400;
				margin: 8px 0 32px;
				span {
					color: rgba(0, 0, 0);
				}
			}
		}
	}
	.iphonex .m-detail {
		padding-bottom: 32px;
	}
</style>
